import { SpotlightCard as AkSpotlightCard } from '@atlaskit/onboarding';
import type { SpotlightCardProps } from '@atlaskit/onboarding/types';

import { wrapComponentForChoreographer } from '../utils';

export const SpotlightCard = wrapComponentForChoreographer<SpotlightCardProps>(AkSpotlightCard);
